// Warm the player route's JS bundle in the background.
//
// VideoPlayer -> hls.js is a big chunk (~185 kB gz), and it is code-split out
// of the home page now (see App.tsx) so that the landing page stays small.
// That means it has to be downloaded the first time a link is opened -
// starting that download while the user is still pasting/typing the URL makes
// the Play tap instant instead of a wait on mobile data.

let warming: Promise<unknown> | null = null

export function prefetchPlayerPage(): void {
  if (warming) return
  warming = import('../pages/PlayerPage').catch(() => {
    warming = null // transient failure (offline) -> allow a retry later
  })
}
